import { render, staticRenderFns } from "./holddollar-dialog.vue?vue&type=template&id=478ba7ae&scoped=true&"
import script from "./holddollar-dialog.vue?vue&type=script&lang=js&"
export * from "./holddollar-dialog.vue?vue&type=script&lang=js&"
import style0 from "./holddollar-dialog.vue?vue&type=style&index=0&id=478ba7ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ba7ae",
  null
  
)

export default component.exports